export default {
      id: "icon-location-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-location",
      toString: function () {
        return this.url;
      }
    }